import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconDrawGirl from 'svg/drawGirl.svg'
import IconWomanNotebook from 'svg/womanNotebook.svg'
import { getFullUrlToSsr } from 'utils/router'
import TemplateCardsBlock from './TemplateCardsBlock/TemplateCardsBlock.jsx'

import './EmptyProjectList.scss'

const EmptyProjectList = ({ isPublishedTab, onCreateProject }) => {
    const { t } = useTranslation()
    const {
        organizations: { selectedMember },
        user_details,
    } = useSelector(state => ({
        organizations: state.organizations,
        user_details: state.user_details,
    }))

    //if not current user
    if (selectedMember && selectedMember.userId !== user_details.id) {
        return (
            <div className="empty-member-project-list">
                <div className="image">
                    <img src={IconWomanNotebook} alt="" />
                </div>
                <h3>
                    <b>{selectedMember.name}</b>
                </h3>
                <h4>{isPublishedTab ? t("hasn't published projects yet") : t("hasn't created any projects yet.")}</h4>
            </div>
        )
    }

    //if current user in published
    if (isPublishedTab) {
        return (
            <div className="empty-member-project-list">
                <div className="image">
                    <img src={IconDrawGirl} alt="" />
                </div>
                <h3>{t('Here you will find your published projects')}</h3>
                <h4>{t('You have no published projects yet.')}</h4>
                <div className="buttons">
                    <a
                        href={getFullUrlToSsr('/template-gallery')}
                        className="button-style"
                        data-size="lg"
                        data-variant="primary"
                    >
                        {t('Create from a template')}
                    </a>
                </div>
            </div>
        )
    }

    //if current user in drafts
    return (
        <div className="empty-project-list">
            <div className="empty-project-list__header">
                <div className="empty-project-list__header-image">
                    <img src={IconDrawGirl} alt="" />
                </div>
                <div className="empty-project-list__header-content">
                    <h3>{t('Create your first project!')}</h3>
                    <p>{t('Here are some ideas to get you started')}</p>
                    <div className="empty-project-list__buttons">
                        <a
                            href={getFullUrlToSsr('/template-gallery')}
                            className="empty-project-list__buttons-button template-icon"
                            data-variant="primary"
                        >
                            {t('Select a template')}
                        </a>
                        <div className="empty-project-list__buttons-line">
                            <div
                                onClick={() => onCreateProject()}
                                className="empty-project-list__buttons-button pencil-icon"
                                data-variant="secondary"
                            >
                                {t('Create from scratch')}
                            </div>
                            <a
                                href="https://help.interacty.me/en/category/2372-getting-started"
                                className="empty-project-list__buttons-button library-icon"
                                data-variant="secondary"
                                target="_blank"
                            >
                                {t('Learn')}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <TemplateCardsBlock onCreateProject={onCreateProject} />
        </div>
    )
}

export default EmptyProjectList
